const NO_DISCOUNT_VARIANT_IDS = [
  '55195584463221',
  '54954390716789',
  '54954561634677',
  '54954526441845',
  '55195584561525',
];
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".product_atc").forEach(button => {
    button.addEventListener("click", () => {
      const productId = button.dataset.productId;
      const modal = document.getElementById(`modal-${productId}`);
      if (!modal) return;
      modal.classList.remove("hidden");

      const content = modal.querySelector(".modal-content");
      if (content) {
        content.classList.remove("animate");
        void content.offsetWidth; 
        content.classList.add("animate"); 
      }

      modal.addEventListener("click", (e) => {
        if (e.target === modal) {
          modal.classList.add("hidden");
        }
      });
    });
  });

  document.querySelectorAll(".close-modal").forEach(btn => {
    btn.addEventListener("click", () => {
      btn.closest(".product-modal").classList.add("hidden");
    });
  });

  document.querySelectorAll(".collection-modal-form").forEach(form => {
    const isB2B = (window.IS_B2B === true) || (form?.dataset?.b2b === "true");
    const productId = form.dataset.productId;
    const handle = form.dataset.productHandle;
    const quantityEl = form.querySelector(`#quantity-${productId}`);
    let quantity = 1;

      function applySubscriptionVisibility(form, variant) {
    const subscriptionWidgetEl = form.querySelector('[data-subscription-widget]');
    if (!subscriptionWidgetEl) return;

    const hasSellingPlan = Array.isArray(variant?.selling_plan_allocations) &&
                           variant.selling_plan_allocations.length > 0;
    const shouldHideWidget = isB2B || !hasSellingPlan;

    if (shouldHideWidget) {
      subscriptionWidgetEl.style.setProperty('display', 'none', 'important');
      subscriptionWidgetEl.classList.add('hidden');

      const oneTimeRadio = form.querySelector('.purchase-option[value="onetime"]');
      if (oneTimeRadio) oneTimeRadio.checked = true;
    } else {
      subscriptionWidgetEl.style.removeProperty('display');
      subscriptionWidgetEl.classList.remove('hidden');

      const subsRadio = form.querySelector('.purchase-option[value="subscription"]');
      if (subsRadio && !isB2B) subsRadio.checked = true;
    }

    if (typeof updateSubscriptionArrow === 'function') {

    }
  }
  

        const updateSubscriptionArrow = () => {
          const subsInput = form.querySelector('.purchase-option.subs_save');
          const dropContainer = form.querySelector('.quicBuy_sellingOptions');
          const subsPerks = form.querySelector('.subs_perks');
          const rewardsLink = form.querySelector('.rewards-link');
          const isVisible = subsInput && !subsInput.closest('.subscription-option')?.classList.contains('hidden');
          const isChecked = subsInput?.checked;
        
          if (isVisible && isChecked) {
            dropContainer?.classList.add('drop_arrow');
            subsPerks?.classList.remove('hidden');
            rewardsLink?.classList.remove('hidden');
          } else {
            dropContainer?.classList.remove('drop_arrow');
            subsPerks?.classList.add('hidden');
            rewardsLink?.classList.add('hidden');
          }
        };

    setTimeout(updateSubscriptionArrow, 0); 
    form.querySelectorAll('.purchase-option').forEach(radio => {
      radio.addEventListener('change', updateSubscriptionArrow);
    });

    fetch(`/products/${handle}.js`)
    .then(r => r.json())
    .then(variantData => {
      const validCombinations = variantData.variants.map(v => v.options);
      const defaultVariant = variantData.variants[0];
        if (defaultVariant) {
          updatePrices(form, defaultVariant);
        }
      const hasVariantOptions = form.querySelectorAll(".variant-option").length > 0;
      if (!hasVariantOptions) {
        form.querySelectorAll(".purchase-option").forEach(radio => {
          radio.addEventListener("change", () => {
            updateSubscriptionArrow();
            updatePrices(form, defaultVariant);
          });
        });
      }
      const fieldsets = form.querySelectorAll("fieldset");
      let flavourIndex = -1;
      let packIndex = -1;

      fieldsets.forEach((fieldset, index) => {
        const legend = fieldset.querySelector("legend");
        if (!legend) return;
        const label = legend.textContent.trim().toLowerCase().replace(":", "");
        if (label.includes("flavour")) flavourIndex = index;
        if (label.includes("pack")) packIndex = index;
      });
          
      const modalEl = form.closest('.product-modal');
          let hiddenIds = new Set();
          try {
            const metaEl = modalEl?.querySelector('[data-variant-metafields][data-product-id]');
            const metaArr = JSON.parse(metaEl?.textContent || '[]');
            hiddenIds = new Set(
              metaArr
                .filter(m => m && (m.hide_variant === true || m.hide_variant === 'true' || m.hide_variant === 1 || m.hide_variant === '1'))
                .map(m => m.id)
            );
          } catch (_) {
          }

        const variantFor = (flavour, pack) => {
          return (variantData.variants || []).find(v =>
            v.options[flavourIndex] === flavour &&
            v.options[packIndex] === pack
          ) || null;
        };

        if (flavourIndex !== -1 && packIndex !== -1) {
          const flavourInputs = fieldsets[flavourIndex].querySelectorAll(".variant-option");
          const packInputs = fieldsets[packIndex].querySelectorAll(".variant-option");
        
        flavourInputs.forEach(input => {
          input.addEventListener("change", () => {
            const selectedFlavour = input.value;
        
            let firstValidPackInput = null;
        
            packInputs.forEach(packInput => {
              const packValue = packInput.value;
              const isValid = validCombinations.some(combo =>
                combo[flavourIndex] === selectedFlavour &&
                combo[packIndex] === packValue
              );

              // NEW: if that combo maps to a variant that is flagged hidden, treat it as NOT visible
              const v = variantFor(selectedFlavour, packValue);
              const isHidden = v ? hiddenIds.has(v.id) : false;

              const show = isValid && !isHidden;

              const li = packInput.closest("li") || packInput.parentElement;
              if (li) li.style.display = show ? "" : "none";

              // if now hidden and it was selected, unselect so your UI can recover
              if (!show && packInput.checked) {
                packInput.checked = false;
                packInput.parentElement?.classList?.remove("selected");
              }

              // remember the first visible & valid option to auto-select later
              if (show && !firstValidPackInput) {
                firstValidPackInput = packInput;
              }
            });

              
              if (firstValidPackInput) {
                firstValidPackInput.checked = true;
                firstValidPackInput.dispatchEvent(new Event("change")); 
              }
            });
          });
          
          const checkedFlavour = Array.from(flavourInputs).find(i => i.checked);
          if (checkedFlavour) checkedFlavour.dispatchEvent(new Event("change"));
                }
            });

    form.querySelector(".increase-qty").addEventListener("click", () => {
      quantity++;
      quantityEl.textContent = quantity;
            });

    form.querySelector(".decrease-qty").addEventListener("click", () => {
      if (quantity > 1) quantity--;
      quantityEl.textContent = quantity;
            });

    form.querySelectorAll(".variant-option").forEach(input => {
      input.addEventListener("change", async () => {
        const groupName = input.name;
        const groupInputs = form.querySelectorAll(`input[name="${groupName}"]`);
        groupInputs.forEach(i => i.parentElement.classList.remove("selected"));
        input.parentElement.classList.add("selected");

        const options = Array.from(form.querySelectorAll(".variant-option")).reduce((acc, input) => {
          if (input.checked) {
            acc[parseInt(input.dataset.optionPosition)] = input.value;
          }
          return acc;
        }, []);

        const variant = await fetchVariantByOptions(handle, options);
        if (!variant) return; 
        
        console.log("Selected variant:", variant);
    
        // Subscription logic
        const subscriptionWidgetEl = form.querySelector('[data-subscription-widget]');
        const hasSellingPlan = Array.isArray(variant.selling_plan_allocations) && variant.selling_plan_allocations.length > 0;
        const shouldHideWidget = isB2B || !hasSellingPlan;
        
        if (subscriptionWidgetEl) {
          if (shouldHideWidget) {
              subscriptionWidgetEl.style.setProperty('display', 'none', 'important');
              subscriptionWidgetEl.classList.add('hidden');
          
            const oneTimeRadio = form.querySelector('.purchase-option[value="onetime"]');
            if (oneTimeRadio) oneTimeRadio.checked = true;
          } else {
            // show widget (retail only)
            subscriptionWidgetEl.style.removeProperty('display');
            subscriptionWidgetEl.classList.remove('hidden');

            const subsRadio = form.querySelector('.purchase-option[value="subscription"]');
            if (subsRadio) subsRadio.checked = true;
          }
          updateSubscriptionArrow();
        }

        // Selling plan
        const planSelect = form.querySelector(".selling-plan-selector");
        const planDataScript = form.closest(".product-modal").querySelector("[data-selling-plans]");
        planSelect.innerHTML = "";

        if (!shouldHideWidget) {
          let sellingPlanData = [];
          if (planDataScript) {
            try { sellingPlanData = JSON.parse(planDataScript.textContent || "[]"); } catch {}
          }

          if (sellingPlanData.length > 0) {
            variant.selling_plan_allocations.forEach(allocation => {
              const planId = allocation.selling_plan_id;
              let planName = null;
              for (const group of sellingPlanData) {
                const match = group.selling_plans.find(p => p.id === planId);
                if (match) { planName = match.name; break; }
              }
              if (planName) {
                const option = document.createElement("option");
                option.value = planId;
                option.textContent = planName;
                planSelect.appendChild(option);
              }
            });
            planSelect.disabled = false;
            planSelect.classList.remove("hidden");
            planSelect.addEventListener("change", () => updatePrices(form, variant));
          } else {
            planSelect.disabled = true;
            planSelect.classList.add("hidden");
          }
        } else {
          planSelect.disabled = true;
          planSelect.classList.add("hidden");
        }

          form.querySelectorAll('.purchase-option').forEach(radio => {
            radio.addEventListener('change', () => {
              updateSubscriptionArrow();
              updatePrices(form, variant);
            });
          });
          updatePrices(form, variant);
      });
    });

    form.querySelector(".add-to-cart-btn").addEventListener("click", async () => {
      const options = Array.from(form.querySelectorAll(".variant-option")).reduce((acc, input) => {
        if (input.checked) {
          acc[parseInt(input.dataset.optionPosition)] = input.value;
        }
        return acc;
      }, []);

      const variant = await fetchVariantByOptions(handle, options);
      if (!variant) return alert("Variant not found");

      const purchaseOption = form.querySelector(".purchase-option:checked")?.value;
      const sellingPlanInput = form.querySelector(".selling-plan-selector");
      const sellingPlanId = purchaseOption === "subscription" ? parseInt(sellingPlanInput.value) : null;

      const payload = {
        items: [
          {
            id: variant.id,
            quantity,
            ...(sellingPlanId ? { selling_plan: sellingPlanId } : {})
          }
        ]
      };

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      })
        .then(res => res.json())
        .then(() => {
          const modal = document.getElementById(`modal-${productId}`);
          modal.classList.add("hidden");
        })
        .catch(err => console.error("Add to cart error", err));
    });

      const modalEl   = form.closest('.product-modal');
      const stickyBar = modalEl?.querySelector('#quick-buy-sticky-atc');
      const stickyBtn = stickyBar?.querySelector('.sticky-atc-btn');

      if (stickyBtn) {
        stickyBtn.addEventListener('click', () => {
          form.querySelector('.add-to-cart-btn')?.click(); // reuse your existing flow
        });

        // Keep sticky price in sync with the form’s displayed price (no changes to updatePrices needed)
        const stickyPrice = stickyBar.querySelector('[data-sticky-price]');
        const selectedPriceEl = form.querySelector('.selected-price');
        if (stickyPrice && selectedPriceEl) {
          const syncPrice = () => { stickyPrice.textContent = selectedPriceEl.textContent.trim(); };
          syncPrice();
          const mo = new MutationObserver(syncPrice);
          mo.observe(selectedPriceEl, { childList: true, subtree: true, characterData: true });
        }
      }
  });


        function updatePrices(form, variant) {
          const tags = form.dataset.productTags.split(',');

          const hasCustomPrice = tags.includes('custom_price');

          const originalPrice = (variant.price / 100).toFixed(2);
          const adjustedPrice = ((variant.price * 0.85) / 100).toFixed(2);
          const compareAtPrice = variant.compare_at_price != null
          ? (variant.compare_at_price / 100).toFixed(2)
          : null;

          let discountedPrice = null;
          const allocation = variant.selling_plan_allocations?.[0];
          const adjustment = allocation?.price_adjustments?.[0];

          if (adjustment?.price) discountedPrice = (adjustment.price / 100).toFixed(2);

          const discountPercent = adjustment?.price
            ? Math.trunc(((variant.price - adjustment.price) / variant.price) * 100)
            : null;
        
          
          form.querySelectorAll(".original-price").forEach(el => {
            el.textContent = `£${originalPrice}`;
          });

          form.querySelectorAll(".adjusted-price").forEach(el => {
            el.textContent = `£${adjustedPrice}`;
          });

          const price = Number(variant.price);
          const compare = Number(variant.compare_at_price);
          const hasCompare = Number.isFinite(compare) && compare > price;
          
          form.querySelectorAll(".compare-at-price").forEach(el => {
            if (hasCompare) {
              el.textContent = `£${(variant.compare_at_price / 100).toFixed(2)}`;
              el.classList.remove("hidden");
            } else {
              el.textContent = "";
              el.classList.add("hidden");
            }
          });

          form.querySelectorAll(".subs-compare-at-price").forEach(el => {
            el.textContent = `£${originalPrice}`;
          });
        
          form.querySelectorAll(".discounted-price").forEach(el => {
            el.textContent = discountedPrice ? `£${discountedPrice}` : "";
          });
          
          
          form.querySelectorAll(".sellingPlan_discount").forEach(el => {
            el.textContent = discountPercent ? `${discountPercent}% OFF` : "";
          });
        
         
          const selectedPriceEl = form.querySelector(".selected-price");
          const purchaseType = form.querySelector('.purchase-option:checked')?.value;

          const isExcludedVariant = NO_DISCOUNT_VARIANT_IDS.includes(String(variant.id));
          const canUseAdjustedPrice = hasCustomPrice && !isExcludedVariant;

          if (selectedPriceEl) {
            selectedPriceEl.textContent =
              purchaseType === 'subscription' && discountedPrice
                ? `£${discountedPrice}`
                : canUseAdjustedPrice
                  ? `£${adjustedPrice}`
                  : `£${originalPrice}`;
          }
        }
  
        async function fetchVariantByOptions(handle, options) {
          const url = `/products/${handle}.js`;
          const res = await fetch(url);
          const data = await res.json();
          return data.variants.find(v =>
            options.every((opt, idx) => opt === v.options[idx])
          );
        }
      });




document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.product-modal').forEach((modal) => {
    const content    = modal.querySelector('.modal-content');
    const sticky     = modal.querySelector('#quick-buy-sticky-atc');
    const primaryATC = modal.querySelector('.product-modal-form .add-to-cart-btn');
    if (!content || !sticky || !primaryATC) return;

    sticky.classList.add('hidden');
    sticky.classList.remove('block');

    const toggleSticky = (mainVisible) => {
      const show = !mainVisible;
      sticky.classList.toggle('hidden', !show);
      sticky.classList.toggle('block', show);
    };

    const io = new IntersectionObserver(
      (entries) => toggleSticky(entries[0]?.isIntersecting === true),
      { root: content, threshold: 0.25 }
    );
    io.observe(primaryATC);

    // DO NOT disconnect on close; the observer will recompute when reopened
  });
});

